import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import './CheckoutPages.css';

function CheckoutCancelPage() {
  return (
    <div className="checkout-page" data-testid="checkout-cancel-page">
      <div className="checkout-container">
        <div className="checkout-status cancel" data-testid="cancel-status">
          <div className="cancel-icon">
            <XCircle size={64} />
          </div>
          <h1>Order Cancelled</h1>
          <p className="cancel-message">
            Your order was cancelled and you have not been charged.
            No worries &mdash; the collections are still here whenever you&apos;re ready.
          </p>

          <div className="cancel-reassurance">
            <p>
              Take your time. Choose the collection that feels right for your family.
            </p>
          </div>

          <div className="checkout-actions">
            <Link to="/shop" className="btn btn-primary" data-testid="return-shop-btn">
              See the Collections
            </Link>
            <Link to="/" className="btn btn-secondary" data-testid="return-home-btn">
              Return Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CheckoutCancelPage;
